// import { createTheme } from '@mui/material/styles';

// import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

// const theme = createTheme({
// 	breakpoints: breakpoints,
// 	mixins: mixins,
// });

const greenDot = '#4FEA5A';
const yellowDot = '#FFEA84';
const redDot = '#F00';

export const styles = {};

export const overrides = {
	'.BeachAccess-root': {
		'.BeachAccess-map': {
			width: '100%',
			height: 'calc(100vh - 200px)',

		},
		
	},

	'.BeachAccess-mapFilters': {
		padding: remCalc('55 45 0 0'),
		'.BeachAccess-mapFilters-inside': {
			...mixins.glass,
			padding: remCalc(40),
			background: 'rgba(255, 255, 255, 0.35)',
			width: '324px',
			color: getColor('ivory', 800),

			form: {
				display: 'flex',

				marginBottom: remCalc(40),
				'.SearchField-input': {
					'.MuiFormLabel-root': {
						fontSize: remCalc(14),
					},

					'.MuiInputBase-root': {
						borderRadius: 0,
					},

					'.MuiInputBase-input': {
						fontSize: remCalc(14),
					},
				},
				'.SearchField-search': {
					background: getColor('ivory', 700),
					padding: remCalc('0 20'),
					borderRadius: 0,
				},
			},

			'.mapFilters-container': {
				display: 'flex',
				flexDirection: 'column',
				gap: remCalc(20),
				'.mapFilters-header': {
					textTransform: 'uppercase',
				},
				'.mapFilters-label': {
					display: 'flex',
					alignItems: 'center',
					gap: remCalc(10),
					label: {
						display: 'flex',
						gap: remCalc(10),
						alignItems: 'center',
						fontSize: remCalc(16),
					},
					svg: {
						width: remCalc(17),
						height: remCalc(17),
					},
					'input[type="checkbox"]': {
						appearance: 'none',
						width: remCalc(20),
						height: remCalc(20),
						borderRadius: '100%',
						margin: '0 0 0 auto',
						border: `1px solid ${getColor('ivory', 600)}`,
						position: 'relative',

						'&::after': {
							content: '""',
							position: 'absolute',
							left: '50%',
							top: '50%',
							width: '35%',
							height: '55%',
							border: `2px solid ${getColor('ivory', 800)}`,
							borderTop: 0,
							borderLeft: 0,
							opacity: 0,
							transform: 'translate(-50%, -62%) rotate(45deg)',
							transition: 'opacity 120ms ease',
						},

						'&:checked::after': {
							opacity: 1,
						},
					},
				},
				'.mapFilters-label.county-owned': {
					svg: {
						color: greenDot,
					}
				},
				'.mapFilters-label.limited-access': {
					svg: {
						color: yellowDot,
					}
				},
				'.mapFilters-label.private-beach': {
					svg: {
						color: redDot,
					}
				},
			},

		},
	},

	'.BeachAccess-mapLegendButton': {
		marginBottom: remCalc(60),
	},

	'.BeachAccess-InfoWindow': {
		padding: remCalc('0 40 20 40'),
		display: 'flex',
		flexDirection: 'column',
		gap: remCalc(20),

		'.BeachAccess-InfoWindow-title': {
			fontSize: remCalc(16),
			fontFamily: 'var(--heading-font)',
			color: getColor('ivory', 800),
			fontWeight: 500,
			textTransform: 'uppercase',
			letterSpacing: '2px',
			display: 'flex',
			gap: remCalc(20),
			alignItems: 'center',

			'.icon': {
				border: `1px solid ${getColor('ivory', 600)}`,
				width: remCalc(52),
				height: remCalc(52),
				borderRadius: '100%',
				display: 'flex',
				aspectRatio: '1/1',
				alignItems: 'center',
				justifyContent: 'center',
				img: {
					display: 'block',
					maxWidth: '50%',
					maxHeight: '50%',
				}
			}
		},

		'.BeachAccess-InfoWindow-address, .BeachAccess-InfoWindow-features': {
			color: getColor('ivory', 800),
			fontSize: remCalc(14),
			fontWeight: 500,
		},

		'.BeachAccess-InfoWindow-buttons': {
			display: 'flex',
			flexDirection: 'column',
			gap: remCalc(10),

			'.BeachAccess-InfoWindow-button': {
				color: getColor('ivory', 600),
				justifyContent: 'left',
				padding: 0,
				gap: remCalc(20),
				fontFamily: 'var(--heading-font)',
				letterSpacing: '2px',
				fontSize: remCalc(16),
				fontWeight: 500,
				svg: {
					width: remCalc(20),
				}
			},
		},


		'.BeachAccess-InfoWindow-conditionsLine': {
			display: 'flex',
			textTransform: 'uppercase',
			gap: remCalc(10),
			alignItems: 'center',
			color: getColor('ivory', 600),
			marginBottom: remCalc(10),
			svg: {
				width: remCalc(20),
				height: remCalc(20),
			},
			'.BeachAccess-InfoWindow-flag': {
				margin: remCalc('0 16'),
			},
			'.BeachAccess-InfoWindow-conditions': {
				fontFamily: 'var(--heading-font)',
				letterSpacing: '2px',
			},
		}
	},

	'.BeachAccess-Legend': {
		'.Legend-Title': {
			'.MuiTypography-root': {
				display: 'flex',
				gap: remCalc(20),
				alignItems: 'center',
			},
		},
		'.Legend-Category-full': {
			color: greenDot,
		},
		'.Legend-Category-limited': {
			color: yellowDot,
		},
		'.Legend-Category-private': {
			color: redDot,
		},
		'.Legend-Filter-List': {
			margin: 0,
			padding: 0,
			listStyle: 'none',
			display: 'flex',
			flexDirection: 'column',
			gap: remCalc(64),

			li: {
				'.Legend-Filter-Title': {
					display: 'flex',
					gap: remCalc(20),
					alignItems: 'center',
					'.MuiTypography-root': {
						fontWeight: 400,
					},
					img: {
						width: remCalc(32),
					},
				},
			},
		},
	},
};

export default styles;